const SummaryDelta = require("SummaryDelta/summary-delta");
const Tooltip = require("app/shared/components/Tooltip/tooltip");

const propTypes = {
  value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.element]),
  delta: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.element]),
  deltaType: React.PropTypes.oneOf(["negative", "positive", "neutral"]),
  big: React.PropTypes.bool,
  title: React.PropTypes.string,
  className: React.PropTypes.string,
  tooltipText: React.PropTypes.string,
  deltaTooltipText: React.PropTypes.string,
  url: React.PropTypes.string
}

const defaultProps = {
  value: 0,
  delta: 0,
  deltaType: "neutral",
  big: false,
  title: "",
  delta: 0,
  className: "",
  tooltipText: "",
  deltaTooltipText: "",
  url: null
};

function summaryValue(value, big, url) {
  const className = (big ? "fs-50" : "fs-22") + " mb-5";

  if (url) {
    return (
      <a href={url} className={`${className} seamless-link`} target="_blank">
        {value}
      </a>
    );
  }

  return (
    <div className={className}>
      {value}
    </div>
  );
}

function Summary(props) {
  return (
    <div className={`${props.className}`}>
      <h6 className="text-muted fw-normal mt-0 mb-5">
        {props.title}
      </h6>

      <Tooltip html title={props.tooltipText} container="#tooltip-container" >
        {summaryValue(props.value, props.big, props.url)}
      </Tooltip>

      <SummaryDelta
        deltaType={props.deltaType}
        value={props.delta}
        tooltipText={props.deltaTooltipText}
      />
    </div>
  );
}

Summary.propTypes = propTypes;
Summary.defaultProps = defaultProps;

module.exports = Summary;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/summary.jsx